import i18next from "i18next";
import moment from "moment";
import * as yup from "yup";
import { DATE_TIME_FORMAT_TYPES } from "../configs/constants/DateTimeFormatTypes";
import { JobShift } from "../models/Job";

// TODO: Make this work again

export default yup.lazy(
	(shiftList: any) => yup.array().min(1, "SHIFTS_IS_REQUIRED")
	// .of(
	// 	yup.lazy((currentShiftValue: any) =>
	// 		yup
	// 			.object()
	// 			.shape({
	// 				start: yup.date(),
	// 				end: yup
	// 					.date()
	// 					.min(
	// 						yup.ref("start"),
	// 						`${moment(currentShiftValue?.end).format(
	// 							DATE_TIME_FORMAT_TYPES.DATE_TIME
	// 						)}   (${i18next.t("END_DATE")}) ${i18next.t(
	// 							"END_DATE_START_DATE_VALIDATION"
	// 						)}  ${moment(currentShiftValue?.start).format(
	// 							DATE_TIME_FORMAT_TYPES.DATE_TIME
	// 						)} (${i18next.t("START_DATE")}) `
	// 					),
	// 			})
	// 			.test({
	// 				name: "overlap",
	// 				test: function () {
	// 					const allShifts: JobShift[] = shiftList;
	// 					const currentShift: JobShift = currentShiftValue;

	// 					const excludedCurrentShift = allShifts.filter(
	// 						(cShift) => cShift.start !== currentShift.start && cShift.end !== currentShift.end
	// 					);

	// 					const isBetween = excludedCurrentShift.map((times) => {
	// 						const res = moment(currentShift.start).isBetween(
	// 							times.start,
	// 							times.end,
	// 							"seconds",
	// 							"[]"
	// 						);

	// 						return res;
	// 					});

	// 					const errMessage = `${moment(currentShift.start).format(
	// 						DATE_TIME_FORMAT_TYPES.DATE_TIME
	// 					)} -  ${moment(currentShift.end).format(
	// 						DATE_TIME_FORMAT_TYPES.DATE_TIME
	// 					)} ${i18next.t("SHIFTS_OVERLAP")}`;

	// 					if (isBetween.includes(true)) {
	// 						return this.createError({
	// 							message: errMessage,
	// 						});
	// 					} else {
	// 						return true;
	// 					}
	// 				},
	// 			})
	// 	)
	// )
);
